export default function PieChart(props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) {
	return (
		<svg
			width="28"
			height="28"
			viewBox="0 0 28 28"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M24.5233 18.4439C23.7966 20.1626 22.6599 21.677 21.2126 22.8549C19.7654 24.0328 18.0516 24.8382 16.2212 25.2007C14.3907 25.5632 12.4993 25.4719 10.7124 24.9346C8.92539 24.3973 7.29725 23.4304 5.97028 22.1185C4.6433 20.8066 3.6579 19.1896 3.10023 17.4089C2.54255 15.6281 2.42958 13.7379 2.77119 11.9035C3.11279 10.069 3.89858 8.34614 5.05985 6.88552C6.22111 5.4249 7.7225 4.27098 9.43275 3.52466"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M25.4236 14C25.4236 12.4999 25.1281 11.0144 24.554 9.6284C23.9799 8.24242 23.1385 6.98309 22.0777 5.92231C21.0169 4.86153 19.7576 4.02008 18.3716 3.44599C16.9857 2.8719 15.5002 2.57642 14 2.57642V14H25.4236Z"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}
